import { render, staticRenderFns } from "./ImportChemicals.vue?vue&type=template&id=f834cc58&scoped=true&"
import script from "./ImportChemicals.vue?vue&type=script&lang=js&"
export * from "./ImportChemicals.vue?vue&type=script&lang=js&"
import style0 from "./ImportChemicals.vue?vue&type=style&index=0&id=f834cc58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f834cc58",
  null
  
)

export default component.exports